import React from 'react';
import { 
  HeroSection,
  ContactInfoSection,
  ContactFormSection,
  FAQSection,
  CTASection,
  SEO
} from '../components';

const Contact = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact GrowthVibe - Get in Touch",
    "description": "Ready to start your next project? Contact GrowthVibe for digital marketing and web development services. Get in touch for a free consultation.",
    "url": "https://growthvibe.com/contact",
    "mainEntity": {
      "@type": "Organization",
      "name": "GrowthVibe",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-78610-83648",
        "contactType": "Customer Service",
        "email": "growthvibe2406@gmail.com",
        "availableLanguage": "English"
      },
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Surat",
        "addressRegion": "Gujarat",
        "addressCountry": "IN"
      },
      "url": "https://growthvibe.com"
    }
  };

  return (
    <>
      <SEO
        title="Contact GrowthVibe - Get in Touch for Digital Marketing Services"
        description="Ready to start your next project? Contact GrowthVibe for digital marketing and web development services. Get in touch for a free consultation."
        keywords="contact GrowthVibe, digital marketing consultation, web development contact, IT services inquiry, Surat Gujarat, free consultation"
        url="/contact"
        structuredData={structuredData}
      />
      <div className="contact-page">
        {/* Hero Section */}
        <HeroSection
          title="Get in Touch"
          description="Ready to start your next project? Let's discuss how we can help you achieve your goals."
          showGradient={true}
          heroImage="https://images.unsplash.com/photo-1423666639041-f56000c27a9a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80"
          heroImageAlt="Contact and Communication - Let's Connect"
          layout="minimal"
        />

        {/* Contact Information */}
        <ContactInfoSection />

        {/* Contact Form & Map */}
        <ContactFormSection />

        {/* FAQ Section */}
        <FAQSection />

        {/* CTA Section */}
        <CTASection 
          title="Ready to Get Started?"
          description="Let's discuss your project and see how we can help you achieve your goals."
          primaryButtonText="View Our Services"
          primaryButtonLink="/services"
          secondaryButtonText="Contact Us Now"
          secondaryButtonLink="#contact-form"
        />
      </div>
    </>
  );
};

export default Contact;
